<template>
  <!--  <v-row class="debtor-totals-items flex-sm-column flex-sm-nowrap">-->
  <article class="debt-info-wrapper">
    <div class="stat-item cash-debt-wrapper md">
      <div class="debt-wrapper cash-debt">
        <div class="value">
          {{ info.cash | amountWithCurrency0 }}
        </div>
        <span>Наличные</span>
      </div>
      <div class="debt-wrapper">
        <div class="value">
          {{ info.terminal | amountWithCurrency0 }}
        </div>
        <span>Терминал</span>
      </div>
    </div>
    <div class="stat-item md">
      <div class="value total">
        {{ info.total | amountWithCurrency0 }}
      </div>
      <span>Итого</span>
    </div>
  </article>
</template>

<script>
  export default {
    name: 'TotalDebtInfo',
    props: {
      info: Object,
    },
  }
</script>

<style scoped lang="less">
.debt-info-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;

  @media (max-width: 600px) {
    flex-direction: row;
  }
}
.stat-item {
  text-align: center;
  padding: 20px !important;
  flex-basis: 50%;
}
.debt-wrapper {
  width: 100%;
}
.cash-debt {
  border-bottom: 3px solid #fff;
  padding-bottom: 5px;

  &-wrapper {
    margin-bottom: 12px;
    justify-content: space-around;

    @media (max-width: 600px) {
      margin-bottom: 0;
      margin-right: 12px;
    }
  }
}
</style>
